import { connect } from "react-redux";
import { compose } from "recompose";
import { openWizard } from "src/modules/pairing/duck/actions";
import { withApp } from "src/components/App/Context";
import { removePairedDevice } from "src/modules/device/duck/actions";

import PairedDevices from "./PairedDevices";
import {
  hasFamilyAccount,
  getXmppLogin
} from "src/modules/auth/duck/selectors";
import { withMessenger } from "src/modules/messenger/Provider/index";

function mapStateToProps(state) {
  return {
    hasFamilyAccount: hasFamilyAccount(state),
    thisDeviceJid: getXmppLogin(state)
  };
}
const enhance = compose(
  withMessenger,
  withApp,
  connect(mapStateToProps, {
    openWizard: () => openWizard({ initialStep: "manual-pairing" }),
    removePairedDevice
  })
);

export default enhance(PairedDevices);
